import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export function initMasonry() {
    const grids = document.querySelectorAll('.masonry-grid');

    grids.forEach(grid => {
        const $grid = $(grid);

        if (!$grid.length) return;

        var imgLoad = imagesLoaded(grid);

        imgLoad.on('progress', function (image, elem, message) {
            //$grid.reloadItems();
            //console.log("Progress: " + message);
        });

        imgLoad.on('fail', function () {
            console.log('all images loaded, at least one is broken');
        });

        imgLoad.on('always', function (instance) {
            console.log("Always: " + instance);

            const masonry = new Masonry(grid, {
                itemSelector: '.masonry-grid-item',
                percentPosition: true,
                columnWidth: '.masonry-grid-sizer',
                gutter: 24,
                transitionDuration: 0
            });
        });
    });
}


